module.exports = __webpack_public_path__ + "static/media/detailIOT.ae46c7ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/de/detailIOT.png
// module id = 83
// module chunks = 0